import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import usePdpIsModularBYOProduct from 'components/consumer/PDP/state/context/usePdpIsModularBYOProduct';
import getBreadcrumbsForPage from 'commons/getBreadcrumbsForPage';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';

function addHomeAndProductName(breadCrumbItems, productName) {
  const result = breadCrumbItems.concat({
    label: productName,
    link: '',
  });
  if (result[0].label === 'Home') {
    return result;
  }
  return [{ label: 'Home', link: '/shop' }].concat(result);
}

const usePDPBreadcrumbs = () => {
  const pdpIsModularBYOProduct = usePdpIsModularBYOProduct();
  const params = useParams();
  const { loading, error, data: productDetails } = usePDPBasicDetails();

  const breadCrumbs = useMemo(() => {
    if (productDetails?.name) {
      const productName = productDetails?.name;
      const categoryName = params?.category;

      if (pdpIsModularBYOProduct) {
        const productBreadCrumbs = [
          { label: 'Home', link: '/' },
          { label: 'Modular sofas', link: '/modular-sofas/' },
          { label: productName, link: '' },
        ];
        return productBreadCrumbs;
      }
      if (categoryName) {
        const allBreadCrumbs = getBreadcrumbsForPage('pdp');
        const productBreadCrumbs =
          allBreadCrumbs?.[categoryName] &&
          allBreadCrumbs?.[allBreadCrumbs[categoryName]]
            ? addHomeAndProductName(
                allBreadCrumbs[allBreadCrumbs[categoryName]],
                productName
              )
            : [
                { label: 'Home', link: '/' },
                { label: productName, link: '' },
              ];
        return productBreadCrumbs;
      }
    }
    return [];
  }, [pdpIsModularBYOProduct, params?.category, productDetails?.name]);

  return {
    loading,
    error,
    data: breadCrumbs,
  };
};

export default usePDPBreadcrumbs;
